import { render, staticRenderFns } from "./RegisterFormForeignFinalStep.vue?vue&type=template&id=7d1f2f29&scoped=true&"
import script from "./RegisterFormForeignFinalStep.vue?vue&type=script&lang=js&"
export * from "./RegisterFormForeignFinalStep.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFormForeignFinalStep.vue?vue&type=style&index=0&id=7d1f2f29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1f2f29",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default,FormInputPassword: require('/workspace/components/Form/FormInputPassword.vue').default,FormInput: require('/workspace/components/Form/FormInput.vue').default,FormCheckBox: require('/workspace/components/Form/FormCheckBox.vue').default,Form: require('/workspace/components/Form/index.js').default})
